




























import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import { mapActions } from 'vuex';

import { CrudForm, KeywordsInput, RegularFilterSelector, UiAlert } from '../../components';

import { ApiEnum } from '../../enums';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { Dictionary, EnabledFieldConfig, RegularFilter, RegularFilterSelectedValues } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { CRUD_CONSTS } from '../../store/crud/crud.consts';

export default {
  name: 'blacklist-form',
  components: {
    CrudForm,
    KeywordsInput,
    UiAlert,
    RegularFilterSelector
  },
  mixins: [CrudFormMixin],
  computed: {
    filters: function (): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)();
      filters.lang.config = { ...filters.lang.config, mandatory: true, multiselectDisabled: true };
      return filters;
    },
    valid: function (): boolean {
      if (!this.item.filters.lang.length) {
        return false;
      }
      if (!this.item.terms.length) {
        return false;
      }
      return true;
    },
    enabledFieldConfig: function (): EnabledFieldConfig {
      return {
        disabled: this.existingEnabledBlacklist,
        alertConfig: (this.existingEnabledBlacklist ? {
          type: 'warning',
          message: this.messages.fields.lang.alert
        } : undefined)
      };
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.BLACKLIST,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.blacklist.update),
      item: {
        id: undefined,
        terms: [],
        filters: {
          lang: []
        },
        enabled: true
      },
      messages: this.$epb.messages.tools.blacklist,
      existingEnabledBlacklist: false
    };
  },
  methods: {
    ...mapActions(CRUD_CONSTS.moduleName, {
      fetchData: CRUD_CONSTS.actions.fetchData
    }),
    onFilterChange: async function (filter: RegularFilter, selectedValues: RegularFilterSelectedValues) {
      CrudFormMixin.methods.onFilterChange.bind(this)(filter, selectedValues);
      await this.checkExistingEnabledBlacklist();
    },
    checkExistingEnabledBlacklist: async function () {
      const blacklistsByLanguage = await this.fetchData({
        dataType: this.dataType,
        filters: this.filters
      });
      this.existingEnabledBlacklist =
        !!blacklistsByLanguage.data.items.find((blacklist) => blacklist.enabled && blacklist.id !== this.item.id);
      if (this.existingEnabledBlacklist && this.item.enabled) {
        this.item.enabled = !this.item.enabled;
      }
    }
  },
  watch: {
    'item.filters.lang': async function () {
      this.$emit('updateLoading', { visible: true });
      try {
        await this.checkExistingEnabledBlacklist();
        this.$emit('updateLoading', { visible: false });
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.PLAY));
        this.$emit('updateLoading', { visible: false });
      }
    }
  }
};

